export default [
    {
        id: 'painel-controle-admin',
        title : "Painel de controle",
        icon : "fas fa-tachometer-alt",
        order : 0,
        to : "/dashboard_admin",
        role : [],
        expand:false,
        badge : {
            variant : 'success',
            text : "Admin"
        }
    },
    {
        id: 'painel-controle',
        title : "Painel de controle ",
        icon : "fas fa-tachometer-alt",
        order : 0,
        to : "/dashboard",
        role : [],
        expand:false,
    },
]